import { INPUT_TEXT_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForInputTextElement = createDisplayName(
    INPUT_TEXT_DISPLAY_NAME,
);
